import React from 'react';
import useScrollAnimation from './UseScrollAnimation';
import { useNavigate } from 'react-router-dom';

const Banner = () => {
  useScrollAnimation();
  const navigate = useNavigate();

  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center py-28 md:py-40 overflow-hidden bg-usifresa-dark reveal"
    >
      {/* Background Image and Overlays */}
      <div 
        className="absolute inset-0 z-0 opacity-500 mix-blend-luminosity grayscale"
        style={{
          backgroundImage: "url('/fabrica-usifresa3.jpeg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-hero z-0" />
      
      {/* Decorative Logo Mark Background */}
      <div className="absolute bottom-0 right-0 h-[50%] w-auto opacity-10 z-0 pointer-events-none">
        <img src="/logo-usifresa-branco-cortado.png" alt="Logo Watermark" className="w-full h-full object-contain object-bottom right-0" />
      </div>
      
      {/* Glowing Orb */}
      <div className="absolute top-1/4 -right-20 w-[600px] h-[600px] bg-usifresa-light-blue/10 rounded-full blur-[130px] z-0 animate-pulse-glow pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="w-full xl:max-w-7xl animate-[slideFadeIn_1s_ease-out_forwards]">
          
          {/* TÍTULO COM TAMANHO REDUZIDO NOS DISPOSITIVOS MAIORES */}
          <h1 className="font-title text-[3rem] min-[400px]:text-[3.5rem] sm:text-6xl md:text-[5rem] lg:text-[5.5rem] xl:text-[6rem] 2xl:text-[6.5rem] text-white mb-6 md:mb-10 font-black leading-[0.85] tracking-tighter uppercase lg:whitespace-nowrap">
            Líder de mercado 
          </h1>
          
          <div className="mb-12 max-w-2xl lg:max-w-4xl xl:max-w-5xl flex flex-col gap-5">
            {/* LINHA LARANJA COM ANIMAÇÃO DE CRESCIMENTO */}
            <div className="h-1.5 bg-usifresa-orange rounded-full w-0 animate-[linhaGrow_2s_ease-out_forwards]"></div>
            
            <p className="text-lg md:text-xl lg:text-2xl text-white/70 leading-relaxed font-light">
              Com mais de 20 anos de experiência, fabricamos máquinas e equipamentos de alta performance. Entregamos muito além de maquinário: desenvolvemos
              <span className="text-white font-bold drop-shadow-md"> precisão, inovação e excelência operacionais </span> 
              para impulsionar seus resultados.
            </p>
          </div>
            
          <div className="flex flex-col sm:flex-row gap-5 w-full md:w-auto">
            {/* BOTÃO PRIMÁRIO - LARANJA */}
            <button 
              onClick={() => navigate('/contato')}
              className="w-full sm:w-auto h-14 bg-usifresa-orange text-white  hover:bg-white hover:text-usifresa-dark rounded-full text-[11px] md:text-sm font-extrabold tracking-widest uppercase transition-all duration-300 hover:shadow-[0_0_20px_rgba(255,165,0,0.3)] px-10 flex items-center justify-center gap-2"
            >
              Fale com um especialista
            </button>
            
            {/* BOTÃO SECUNDÁRIO - AZUL */}
            <button 
              onClick={() => {
                document.getElementById('produtos')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full sm:w-auto h-14 bg-usifresa-light-blue text-usifresa-dark hover:bg-white hover:text-usifresa-dark rounded-full text-[11px] md:text-sm font-bold tracking-widest uppercase transition-all duration-300 hover:shadow-[0_0_20px_rgba(173,216,230,0.2)] px-10 flex items-center justify-center gap-2"
            >
              Nossos Equipamentos
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;